// extracted by mini-css-extract-plugin
export default {"delivery-form-summary-wrapper":"Detail_delivery-form-summary-wrapper__q5PbG","item":"Detail_item__cS8CW"};